import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Modal from 'antd/lib/modal/Modal';
import { useForm, Controller } from 'react-hook-form';
import { Select } from 'antd';
import Api from '../Api';
import { errorNotification, successNotification } from '../Snackbar';
import GetField from '../Components/GetField';

const AntSelect = GetField(Select);
const { Option } = Select;

const DeleteModal = props => {
  const { deleteRoleId, roleListArray, roleDeleteModal, hideDeleteModal } =
    props;

  const { control, getValues } = useForm();

  const onDelete = useCallback(async () => {
    try {
      const { newRoleId } = getValues();
      await Api.delete(`/roles/${deleteRoleId}`, { newRoleId });
      successNotification('Role deleted');
      hideDeleteModal();
    } catch (err) {
      errorNotification(err);
    }
  }, [deleteRoleId]);

  return (
    <Modal
      onOk={onDelete}
      visible={roleDeleteModal}
      onCancel={hideDeleteModal}
      centered
      width="30%"
      maskClosable={false}
      title="Select alternate role"
      okText="Submit"
    >
      <Controller
        name="newRoleId"
        control={control}
        render={({ field }) => (
          <AntSelect
            allowClear
            label="Role"
            placeholder="Select role"
            {...field}
          >
            {roleListArray.map(role => (
              <Option key={role.id} value={role.id}>
                {role.role}
              </Option>
            ))}
          </AntSelect>
        )}
      />
    </Modal>
  );
};

DeleteModal.propTypes = {
  hideDeleteModal: PropTypes.func,
  roleDeleteModal: PropTypes.bool,
  roleListArray: PropTypes.any,
  deleteRoleId: PropTypes.number,
};

export default memo(DeleteModal);
